import { render, staticRenderFns } from "./DlgAnimalsDelete.vue?vue&type=template&id=5dce9bbe&scoped=true&"
import script from "./DlgAnimalsDelete.vue?vue&type=script&lang=js&"
export * from "./DlgAnimalsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce9bbe",
  null
  
)

export default component.exports